import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import SEO from "../components/SEO";
import ExperienceCard from "../components/ExperienceCard";
import FilterSelect from "../components/FilterSelect";

const CATEGORIES = [
    { value: "", label: "Toutes les expériences" },
    { value: "gastronomie", label: "Gastronomie" },
    { value: "spiritueux", label: "Spiritueux" },
    { value: "artisan", label: "Artisan & savoir-faire" },
    { value: "culture", label: "Culture & patrimoine" },
    { value: "nature", label: "Nature & jardins" },
    { value: "sport", label: "Sports & nautisme" },
    { value: "bien-etre", label: "Bien-être" },
];

export default function Experiences() {
    const [params, setParams] = useSearchParams();
    const [xps, setXps] = useState([]);
    const [loading, setLoading] = useState(true);
    const cat = params.get("category") || "";

    useEffect(() => {
        setLoading(true);
        api.get("/experiences", { params: { category: cat || undefined, limit: 50 } })
            .then((r) => setXps(r.data))
            .finally(() => setLoading(false));
    }, [cat]);

    const update = (v) => {
        const n = new URLSearchParams(params);
        if (!v) n.delete("category"); else n.set("category", v);
        setParams(n);
    };

    return (
        <>
            <SEO
            title="Expériences vérifiées — châteaux, jardins, manoirs, ateliers"
            description="42 expériences chic du territoire Normandie/Picardie : Château d'Eu (Louis-Philippe), Manoir d'Ango (Renaissance), Château de Rambures, Bois des Moutiers (Lutyens), Jardin Shamrock, verrerie Pochet, Forêt d'Eu, Domaine de Joinville."
            path="/experiences"
        />
            <div className="pt-28" data-testid="experiences-page">
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pt-16 md:pt-24 pb-16">
                <p className="cp-tiny text-cp-foret mb-8">Chapitre VII · Expériences d'exception</p>
                <h1 className="cp-serif text-4xl sm:text-5xl md:text-[56px] lg:text-[72px] xl:text-[92px] leading-[1.02] text-cp-encre max-w-5xl tracking-[-0.025em]">
                    Des expériences,<br /><em className="cp-display-italic text-cp-foret">réelles</em>.
                </h1>
                <p className="cp-serif italic text-xl md:text-2xl font-light text-cp-gris leading-relaxed mt-12 max-w-3xl">
                    Musées classés, jardins remarquables, châteaux ouverts, surf et char à voile, artisans qui travaillent — toutes nos expériences sont des adresses officielles vérifiées. <em>Chaque fiche renvoie vers la source.</em>
                </p>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto py-5 border-y border-cp-border mb-12 sticky top-20 md:top-24 z-30 bg-cp-ivoire/95 backdrop-blur-xl" data-testid="xp-filters">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 items-end">
                    <FilterSelect
                        label="Catégorie"
                        value={cat}
                        onChange={update}
                        testId="xp-filter-category"
                        options={CATEGORIES}
                    />
                    <p className="cp-tiny text-cp-gris sm:col-span-1 md:col-span-3 text-left sm:text-right self-center pt-4">
                        {xps.length} expérience{xps.length > 1 ? "s" : ""}
                        {cat && <button onClick={() => update("")} className="ml-3 text-cp-foret hover:underline cp-serif italic" data-testid="xp-filter-reset">Tout effacer ×</button>}
                    </p>
                </div>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pb-32">
                {loading ? <p className="text-cp-gris">Chargement…</p> : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
                        {xps.map((xp, i) => <ExperienceCard key={xp.id} experience={xp} index={i} />)}
                    </div>
                )}
            </section>
        </div>
    </>

    );
}
